import errorManager from '@/rollbar.js';

const fillMeasurementFields = (select) => {
  // Nascondi tutti gli alert BMI
  document.querySelectorAll('.bmi-alert').forEach((elem) => {
    elem.style.display = 'none';
  });

  // Rimuove dati e resetta gli input
  document.querySelectorAll('.input_desval').forEach((elem) => {
    // Simula removeData: elimino tutti i data-* attribute
    for (let key in elem.dataset) {
      delete elem.dataset[key];
    }

    elem.readOnly = false;

    // Rimuove tutte le classi che iniziano con 'cod-'
    Array.from(elem.classList).forEach((cls) => {
      if (cls.startsWith('cod-')) {
        elem.classList.remove(cls);
      }
    });
  });

  // Rimuove la classe 'bmi-valutation'
  document.getElementById('js-desval3')?.classList.remove('bmi-valutation');

  // Nasconde tutti gli elementi .desval
  document.querySelectorAll('.desval').forEach((elem) => {
    elem.style.display = 'none';
  });

  // Trova l'option selezionata dentro il select
  const selected = select.querySelector('option:checked');

  let num_result;
  if (!selected?.dataset.num || parseInt(selected.dataset.num) === 0) {
    num_result = 1;
  } else {
    num_result = parseInt(selected.dataset.num);
  }

  if (select.value && select.value !== '') {
    const notes = selected.dataset.notes,
      notes_div = document.querySelector('#js-notes');
    notes_div.classList.add('hide');

    if (notes && notes !== '') {
      notes_div.classList.remove('hide');
      notes_div.querySelector('.controls').innerHTML = notes;
    }

    for (let i = 1; i <= num_result; i++) {
      // Mostra il div desval
      const desvalDiv = document.querySelector('.desval' + i);
      if (desvalDiv) desvalDiv.style.display = '';

      // Aggiorna il testo della label
      const label = document.querySelector('label#desval' + i);
      if (label) label.textContent = label.dataset.label || '';

      const desval = selected.dataset['desval' + i] ? JSON.parse(selected.dataset['desval' + i]) : null;

      if (desval) {
        if (selected.dataset.cod && selected.dataset.cod.toUpperCase() === 'BI_CALC') {
          let description = '';
          if (desval.cod === 'DIU') description = 'Diuresi';
          if (desval.cod === 'IDR') description = 'Idratazione';

          if (label && desval.val && desval.val !== '') {
            label.textContent = description + ' ' + desval.val;
          }
        } else {
          if (label && desval.val && desval.val !== '') {
            label.textContent = desval.val;
          }
        }

        const jsDesval = document.getElementById('js-desval' + i);

        if (jsDesval) {
          const lastHeightVal = document.getElementById('last_height')?.value || '';

          if (desval.is_height && lastHeightVal !== '') {
            jsDesval.value = lastHeightVal;
          }

          if (desval.cod && desval.cod !== '') {
            jsDesval.classList.add('cod-' + desval.cod.toLowerCase());
          }

          if (desval.max !== undefined && desval.max !== '') {
            jsDesval.dataset.max = desval.max;
          }
          if (desval.min !== undefined && desval.min !== '') {
            jsDesval.dataset.min = desval.min;
          }
          if (desval.in_range !== undefined && desval.in_range !== '') {
            jsDesval.dataset.in_range = desval.in_range;
          }
        }
      }
    }

    if (!selected.dataset.cod) return;

    if (['bmi', 'imc'].includes(selected.dataset.cod.toLowerCase())) {
      const desval3 = document.getElementById('js-desval3');
      if (desval3) desval3.classList.add('bmi-valutation');

      document.querySelectorAll('.bmi-alert').forEach((elem) => {
        elem.style.display = '';
      });
    }
  }

  // Imposta i campi cod-bmi come readonly
  document.querySelectorAll('.cod-bmi').forEach((elem) => {
    elem.readOnly = true;
  });
};

const setListener = (selector) => {
  selector.on('change', (e) => {
    fillMeasurementFields(document.querySelector(`#${selector.attr('id')}`));
  });
};

const init = (selector) => {
  try {
    fillMeasurementFields(document.querySelector(`#${selector.attr('id')}`));
    setListener(selector);
  } catch (e) {
    errorManager(e);
  }
};

window.SettingForm = {
  init: init,
};
